import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "@/lib/backend";

/**
 * Handles redirects from Supabase Auth (email confirm, OAuth, recovery).
 * Tokens arrive in the URL hash/query; the Supabase client picks them up
 * via detectSessionInUrl.
 */
export function AuthCallback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Anmeldung wird abgeschlossen…");

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const finish = (path: string) => {
      if (!cancelled) navigate(path, { replace: true });
    };

    const hash = typeof window !== "undefined" ? window.location.hash : "";
    const search = typeof window !== "undefined" ? window.location.search : "";
    const params = new URLSearchParams(
      hash.startsWith("#") ? hash.slice(1) : search.startsWith("?") ? search.slice(1) : ""
    );
    const type = params.get("type");

    if (type === "recovery") {
      finish("/auth/reset-confirm");
      return;
    }

    const trySession = async () => {
      const { user } = await auth.getSession();
      if (cancelled) return;

      if (user) {
        // Home routes by role (manage vs onboarding).
        finish("/");
        return;
      }

      attempts += 1;
      if (attempts < 8) {
        window.setTimeout(trySession, 250);
        return;
      }

      setMessage("Bestätigung fehlgeschlagen — bitte erneut anmelden.");
      finish("/auth/login");
    };

    void trySession();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto" />
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
